import React from 'react';
import cx from 'classnames';
import { Content } from '../Content';
import styles from './index.scss';

interface CardProps {
  className?: string;
  direction?: 'horizontal' | 'vertical';
}

export const Card = ({ className, direction = 'vertical' }: CardProps) => {
  return (
    <div
      className={cx(
        styles.Card,
        {
          [styles.CardHorizontal]: direction === 'horizontal',
        },
        className,
      )}>
      <Content />
    </div>
  );
};
